import "./used-instance-style.css";

export const UsedInstances = ({ instances }) => {
  if (!instances) return <div>No instance is using this pool.</div>;

  return (
    <div class="grid-container">
      <div class="grid-item header">ID</div>
      <div class="grid-item header">Name</div>
      <div class="grid-item header">Tenant</div>
      <div class="grid-item header">Status</div>
      <div class="grid-item header">Version</div>

      {instances.map((item) => (
        <>
          <div class="grid-item">{item.id}</div>
          <div class="grid-item">{item.name}</div>
          <div class="grid-item">{item.tenant}</div>
          <div class="grid-item">{item.status}</div>
          <div class="grid-item">{item.version}</div>
        </>
      ))}
    </div>
  );
};
